"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.Paragraph = exports.Info = exports.Title = exports.StyledRow = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  align-items: ", ";\n"], ["\n  align-items: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  text-transform: ", ";\n  margin-bottom: ", "px;\n"], ["\n  color: ", ";\n  font-size: ", ";\n  text-transform: ", ";\n  margin-bottom: ", "px;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  padding: 35px 0px 20px;\n  padding: ", "px 0;\n"], ["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  padding: 35px 0px 20px;\n  padding: ", "px 0;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  max-height: 600px;\n  object-fit: cover;\n  width: 100%;\n"], ["\n  max-height: 600px;\n  object-fit: cover;\n  width: 100%;\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactBootstrap = require("react-bootstrap");

var _globalCss = require("../../../styles/globalCss");

var variable = _interopRequireWildcard(_globalCss);

var _colors = require("../../../styles/colors");

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = exports.StyledRow = _styledComponents2.default.div(_templateObject, function (props) {
  return props.columnPosition || "center";
});

var Title = exports.Title = _styledComponents2.default.h2(_templateObject2, function (props) {
  return props.titleColor || colors.blackColor;
}, function (props) {
  return props.titleFontSize || "30px";
}, function (props) {
  return props.titleText;
}, function (props) {
  return props.bottomSpace || {};
});
var Info = exports.Info = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.topBorderColor || "#ccc";
}, function (props) {
  return props.bottomBorderColor || "#ccc";
}, function (props) {
  return props.contentSpace || "15";
});
var Paragraph = exports.Paragraph = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.textFontSize;
}, function (props) {
  return props.textColor;
});
var Image = exports.Image = _styledComponents2.default.img(_templateObject5);